import { createSelector } from 'reselect'

import { localize } from 'helpers/translator'

const hasText = input => input.text != ''
const validQuestion = question => hasText(question) && question.answers.every(hasText) && question.answers.some(answer => answer.correct)

const quiz_validation_selector = createSelector(
	[ state => state.quiz ],
	quizState => {

		const questions = quizState.questions
		const hasExceedChars = questions.some(question => question.hasExceedChars)
		const valid = !hasExceedChars && questions.every(validQuestion)

		return {
			valid,
			message: valid ? null : (hasExceedChars ? localize('global_review_information_error') : localize('quiz_complete_fields')),
		}

	}
)

export default quiz_validation_selector
